import html2pdf from "html2pdf.js";
import { formatPrice } from "../helpers/formatPrice";
import { makeObjectScreenshot } from "./screenshot";
import { getDate } from "../helpers/getDate";
import { getSpecLink } from "../helpers/api";
import { closeModalLoader, openModalLoader } from "../helpers/openCloseModalLoader";
import { getTableTitle } from "../helpers/getTableTitle";
import { html } from "../helpers/stringHTML";
import { filterArrayFromItem } from "../helpers/filterArrayFromItem";
import { color_dictionary } from "./color_dictionary";

const download_btn = document.getElementById("download_pdf");

const config = {
    margin: [15, 0, 5, 0],
    filename: `Стол Базовый (СП) ${getDate()}.pdf`,
    jsPDF: {
        unit: "px",
        format: "a4",
        orientation: "portrait",
    },
    html2canvas: {
        scale: 4,
        logging: true,
    },
    pagebreak: {
        after: ".pageBreak",
        before: ".pageBreakBefore",
    },
};
const setPdfFileName = (name) => {
    config.filename = name;
};
const savePDF = () => {
    const element = document.getElementById("content");
    html2pdf()
        .set(config)
        .from(element)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                if (i === 1) continue;
                pdf.setPage(i);
                pdf.setFontSize(12);
                pdf.text(`${i}`, pdf.internal.pageSize.getWidth() - 20, pdf.internal.pageSize.getHeight() - 10);
            }
        })
        .save();
};
download_btn?.addEventListener("click", savePDF);

// Преобразования base64 в Blob
export function base64ToBlob(base64, mimeType = "image/jpeg") {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {
        type: mimeType,
    });
}
export async function createFirstPage(data, link, tableName, folderName, typeName) {
    if (!data) {
        console.warn("[createFirstPage] data отсутствует", data);
        return;
    }
    const wrap = document.querySelector(".first-page-spec");
    const link_node = document.getElementById("shared_link");
    link_node.href = link;
    const titleNode = document.getElementById("table_name");
    titleNode.textContent = getTableTitle(tableName, folderName, typeName);
    let res = "";
    const header = "<h2>Технические характеристики</h2>";
    res += header;
    const temp_row = (key, value) => {
        const maxLength = 28; // максимально допустимое количество символов
        let displayValue = value;
        if (value.length > maxLength) {
            displayValue = value.slice(0, maxLength) + "…";
        }
        return `
    <div class="spec__row--first">
        <p>${key}</p>
        <p>${displayValue}</p>
    </div>
    `;
    };
    Object.entries(data).forEach(([key, value], index) => {
        if (key === "id" || index === 1) return; // Пропускаем сам id и второе поле (по типу Стол: такой-то, Стул: такой-то и т.д.)
        res += temp_row(key, value);
    });
    wrap.innerHTML = res;
}
export function createSecondPage(item = null) {
    const servObj = parent.servObj ?? window.servObj;

    const row_temp = (name, type, piece, price = 0, needPageBreak = false, isMultyPieces = false) => {
        const type_string = `${type ? type : ""} ${piece && !type ? piece : ""}`;
        const rowHTML = (_price) => html`
            <div class="spec__row">
                <span class="spec__param">${name}</span>
                <span class="spec__value">${type_string}</span>
                <span class="spec__price">${_price}</span>
            </div>
        `;
        if (!isMultyPieces && piece > 1) {
            const numericPiece = Number(piece);
            const numericPrice = Number(price.replace(/[^\d.-]/g, ""));
            const unitPrice = numericPrice && numericPiece ? numericPrice / numericPiece : numericPrice || 0;
            const formattedUnitPrice = formatPrice(unitPrice);
            return Array.from(
                {
                    length: numericPiece,
                },
                () => rowHTML(formattedUnitPrice),
            ).join("");
        }
        return rowHTML(price);
    };
    const calc = servObj.calc;
    if (!calc) {
        console.warn("[pdf.js] calc не найден");
    }
    let calc_values = !item ? Object.values(calc) : filterArrayFromItem(Object.values(item.userData.calcActives));
    let tableArr = [];
    let baseArr = [];
    let downArr = [];
    let upArr = [];
    let upFullArr = [];
    let upHalfArr = [];

    // Объединяем объекты разделителей — комплекты + штуки (у комплектов из 5 штук и просто штук - разные цены!),
    // чтобы комплекты и штуки были в одной строке
    calc_values = mergeRazdeliteliItems(calc_values, {
        singleName: "Разделители на нижнюю полку (ШТУКИ), шт",
        setName: "Разделители на нижнюю полку (КОМПЛЕКТЫ), шт",
        singleId: "razdeliteli_amount",
        setId: "razdeliteli_komplekt",
        resultName: "Разделители на нижнюю полку, шт",
        resultPosition: "down",
    });
    calc_values = mergeRazdeliteliItems(calc_values, {
        singleName: "Разделители на приборную полку (ШТУКИ), шт",
        setName: "Разделители на приборную полку (КОМПЛЕКТЫ), шт",
        singleId: "razdeliteli_pribornaya_amount",
        setId: "razdeliteli_pribornaya_komplekt",
        resultName: "Разделители на приборную полку, шт",
        resultPosition: "up",
    });

    const isOnlyBaseArrFn = (names = []) => {
        const folderName = item
            ? item.userData.loadData.folderName
            : servObj.redactorModeObject.userData.loadData.folderName;

        return names.includes(folderName);
    };
    const isOnlyBaseArr = isOnlyBaseArrFn(["stoli_podkatnie", "telezhki", "tumbi", "stellazhi", "stulya", "wardrobes"]);

    const hasHalfWidthBlock = !!parent.document.getElementById("half_width");

    let hasEdgeColor = null;
    let hasMetallColor = null;

    if (item) {
        hasEdgeColor = !!item.userData.checkedInputsData.find((el) => el.name === "edge_color");
        hasMetallColor = !!item.userData.checkedInputsData.find((el) => el.name === "metall_color");

        tableArr = filterArrayFromItem(calc_values, "table");
        baseArr = isOnlyBaseArr
            ? filterArrayFromItem(calc_values, "").filter((el) => el.position !== "table")
            : filterArrayFromItem(calc_values, "base");

        if (!isOnlyBaseArr) {
            downArr = filterArrayFromItem(calc_values, "down");
            upArr = filterArrayFromItem(calc_values, "up");
            if (hasHalfWidthBlock) {
                // Если в интерфейсе есть блок "Половинные", тогда заполняем массивы upFullArr и upHalfArr как обычно
                upFullArr = filterArrayFromItem(calc_values, "up__full");
                upHalfArr = filterArrayFromItem(calc_values, "up__half");
            } else {
                // Иначе объединяем их в upArr
                upArr = [
                    ...upArr,
                    ...filterArrayFromItem(calc_values, "up__full"),
                    ...filterArrayFromItem(calc_values, "up__half"),
                ];
            }
        }
    } else {
        hasEdgeColor = !!parent.servObj.redactorModeObject.userData.checkedInputsData.find(
            (el) => el.name === "edge_color",
        );
        hasMetallColor = !!parent.servObj.redactorModeObject.userData.checkedInputsData.find(
            (el) => el.name === "metall_color",
        );

        tableArr = calc_values.filter((base) => base.position === "table" && base.active);
        baseArr = isOnlyBaseArr
            ? calc_values.filter((base) => base.active && base.position !== "table")
            : calc_values.filter((base) => base.position === "base" && base.active);

        if (!isOnlyBaseArr) {
            downArr = calc_values.filter((base) => base.position === "down" && base.active);
            upArr = calc_values.filter((base) => base.position === "up" && base.active);

            if (hasHalfWidthBlock) {
                // Если в интерфейсе есть блок "Половинные", тогда заполняем массивы upFullArr и upHalfArr как обычно
                upFullArr = calc_values.filter((base) => base.position === "up__full" && base.active);
                upHalfArr = calc_values.filter((base) => base.position === "up__half" && base.active);
            } else {
                // Иначе объединяем их в upArr
                upArr = [
                    ...upArr,
                    ...calc_values.filter(
                        (base) => (base.position === "up__full" || base.position === "up__half") && base.active,
                    ),
                ];
            }
        }
    }

    let width = "";
    let depth = "";
    let height = "";
    const servObjColorMetall = parent.servObj.tableColor.changeable_painted_metal_material.current;
    const servObjColorKromka = parent.servObj.tableColor.changeable_kromka_material.current;
    const userDataColorMetall = item?.userData.colors.changeable_painted_metal_material;
    const userDataColorKromka = item?.userData.colors.changeable_kromka_material;
    const color_metal = item
        ? color_dictionary.metall[userDataColorMetall]
        : color_dictionary.metall[servObjColorMetall];
    const color_kromka = item
        ? color_dictionary.kromka[userDataColorKromka]
        : color_dictionary.kromka[servObjColorKromka];
    const total_price_node = document.getElementById("total_price");

    let total = 0;
    let hasZeroPrice = false;

    const isEsdPrice = !item ? calc.isEsdPrice : item.userData.isEsdPrice;

    const sourceArr = [...tableArr, ...baseArr, ...downArr, ...upArr, ...upFullArr, ...upHalfArr];

    // Проверяем все элементы
    sourceArr.forEach((el) => {
        if (!el || !el.active) return;

        let price = 0;

        if (isEsdPrice) {
            if (el.position === "table") {
                price = Number(el.price_esd ?? 0);
            } else {
                price = el.price_esd && el.price_esd !== 0 ? Number(el.price_esd) : Number(el.price) || 0;
            }
        } else {
            price = Number(el.price) || 0;
        }

        if (price === 0) {
            hasZeroPrice = true;
        }

        total += price * (el.piece || 1);
    });

    // если есть 0 → "По запросу"
    if (hasZeroPrice) {
        total = "По запросу";
    }

    const createBaseBlock = () => {
        const wrap = document.querySelector(".configurator__block--base");
        let res = "";
        tableArr.forEach((table) => {
            const price = getCorrectPrice(table, isEsdPrice);
            res += row_temp(table.name, table.type, null, price);
            height = table.height;
            width = table.width;
            depth = table.depth;
            document.getElementById("table_name").textContent = table.title;
        });
        res += row_temp("Исполнение", isEsdPrice ? "Антистатическое" : "Общепромышленное", null, "");
        if (height) res += row_temp("Высота", height, null, "");
        if (width) res += row_temp("Ширина", width, null, "");
        if (depth) res += row_temp("Глубина", depth, null, "");

        if (hasMetallColor) {
            res += row_temp("Цвет металла", color_metal, null, "");
        }

        if (hasEdgeColor) {
            res += row_temp("Цвет кромки", color_kromka, null, "");
        }

        baseArr.forEach((base) => {
            const price = getCorrectPrice(base, isEsdPrice);
            res += row_temp(base.name, base.type, base.piece, price, null, base.isMultyPieces);
        });
        wrap.innerHTML = res;
    };
    const createDownBlock = () => {
        const wrap = document.querySelector(".configurator__block--down");
        let res = "";
        if (downArr.length) {
            res += '<h3 class="configurator__subtitle">Нижние элементы</h3>';
            downArr.forEach((down) => {
                const price = getCorrectPrice(down, isEsdPrice);
                res += row_temp(down.name, down.type, down.piece, price, null, down.isMultyPieces);
            });
        }
        wrap.innerHTML = res;
    };
    const createUpBlock = () => {
        const wrap = document.querySelector(".configurator__block--up");
        let res = "";
        if (upArr.length) {
            res += "<h3 class='configurator__subtitle'>Верхние элементы</h3>";
            upArr.forEach((up) => {
                const price = getCorrectPrice(up, isEsdPrice);
                res += row_temp(up.name, up.type, up.piece, price, null, up.isMultyPieces);
            });
        }
        wrap.innerHTML = res;
    };
    function createUpFullBlock() {
        const wrap = document.querySelector(".configurator__block--up-full");
        let res = "";
        if (upFullArr.length) {
            res += "<h4>Во всю ширину</h4>";
            upFullArr.forEach((up) => {
                const price = getCorrectPrice(up, isEsdPrice);
                res += row_temp(up.name, up.type, up.piece, price, null, up.isMultyPieces);
            });
        }
        wrap.innerHTML = res;
    }
    function createUpHalfBlock() {
        const wrap = document.querySelector(".configurator__block--up-half");
        let res = "";
        if (upHalfArr.length) {
            res += "<h4>Половинные</h4>";
            upHalfArr.forEach((up) => {
                const price = getCorrectPrice(up, isEsdPrice);
                res += row_temp(up.name, up.type, up.piece, price, null, up.isMultyPieces);
            });
        }
        wrap.innerHTML = res;
    }
    createBaseBlock();
    createDownBlock();
    createUpBlock();
    createUpFullBlock();
    createUpHalfBlock();
    total_price_node.textContent = typeof total === "string" ? total : formatPrice(total);

    applySmartPageBreaks(".spec-page-1", ".spec-page-2", {
        safePaddingPx: 60, // безопасное поле снизу
        marginTopPx: 0,
        marginBottomPx: 0,
        childSelector: ".spec__row, .configurator__subtitle, .configurator__block--total, .delivery, .footer",
    });
}
export async function generatePdfWithPageNumbers(element, config) {
    return new Promise((resolve, reject) => {
        html2pdf()
            .set(config)
            .from(element)
            .toPdf()
            .get("pdf")
            .then(function (pdf) {
                const totalPages = pdf.internal.getNumberOfPages();
                for (let i = 1; i <= totalPages; i++) {
                    if (i === 1) continue;
                    pdf.setPage(i);
                    pdf.setFontSize(12);
                    pdf.text(`${i}`, pdf.internal.pageSize.getWidth() - 20, pdf.internal.pageSize.getHeight() - 10);
                }
            })
            .outputPdf("blob")
            .then(resolve)
            .catch(reject);
    });
}
let isProcessing = false;
window.addEventListener("message", async (event) => {
    if (isProcessing) return;
    if (!event.data || event.data.type !== "save-pdf") return;
    const modalTextContent = "Спецификация формируется<br />и будет скачана на ваш ПК";
    openModalLoader(modalTextContent);
    isProcessing = true;
    const servObj = parent.servObj;
    try {
        if (!servObj) {
            console.warn("parent.servObj is undefined");
            return;
        }
        if (servObj.isRedactorMode) {
            const screenshotBase64 = await makeObjectScreenshot();
            if (screenshotBase64) {
                const mainScreenshot = document.getElementById("main_screenshot");
                if (mainScreenshot) {
                    mainScreenshot.innerHTML = "";
                    const img = document.createElement("img");
                    img.src = screenshotBase64;
                    mainScreenshot.appendChild(img);
                } else {
                    console.warn("main_screenshot элемент не найден");
                }
            } else {
                console.warn("Скриншот не сгенерирован");
            }
            const link = await getSpecLink();

            const firstPagePdfData = getFirstPagePdfData(servObj.redactorModeObject);

            const { folderName, typeName, glbName } = parent.servObj.redactorModeObject.userData.loadData;

            await createFirstPage(firstPagePdfData, link, glbName, folderName, typeName);
            await createSecondPage();
            const title = getTableTitle(glbName, folderName, typeName);
            const filename = sanitizeFilename(`${title} ${getDate()}.pdf`);
            setPdfFileName(filename);
            download_btn.click();
            closeModalLoader();
        } else if (servObj.building._objects.length) {
            const JSZip = (await import("jszip")).default;
            const zip = new JSZip();
            const tables = parent.servObj.building._objects;
            for (let i = 0; i < tables.length; i++) {
                const table = tables[i];

                const screenshotBase64 = table.userData.screenshot;
                const title = table.userData.menu_title || "Спецификация";
                if (screenshotBase64) {
                    const mainScreenshot = document.getElementById("main_screenshot");
                    if (mainScreenshot) {
                        mainScreenshot.innerHTML = "";
                        const img = document.createElement("img");
                        img.src = screenshotBase64;
                        mainScreenshot.appendChild(img);
                    } else {
                        console.warn("main_screenshot элемент не найден");
                    }
                } else {
                    console.warn("Скриншот не сгенерирован");
                }
                const linkToConf = await getSpecLink(true, table.userData.saveObjToJson);

                const firstPagePdfData = getFirstPagePdfData(table);

                const { glbName, folderName, typeName } = table.userData.loadData;

                await createFirstPage(firstPagePdfData, linkToConf, glbName, folderName, typeName);
                createSecondPage(table);

                await new Promise((resolve) => setTimeout(resolve, 100));
                const element = document.getElementById("content");
                const rawTitle = `${title} ${getDate()}_${i + 1}.pdf`;
                const filename = sanitizeFilename(rawTitle);
                const pdfBlob = await generatePdfWithPageNumbers(element, {
                    ...config,
                });
                zip.file(filename, pdfBlob);
            }
            const zipBlob = await zip.generateAsync({
                type: "blob",
                platform: "UNIX",
                // Убирает Windows-специфичную кодировку путей (чтобы архив корректно открывался без стороннего архиватора в windows)
                forceZip64: false, // Избегаем формата ZIP64, который плохо понимает Windows (чтобы архив корректно открывался без стороннего архиватора в windows)
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(zipBlob);
            const fileName = `Спецификация ESD ${getDate()}.zip`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            closeModalLoader();
        } else {
            console.warn("Пока нечего сохранять в PDF");
            const modalText = parent.document.getElementById("loader_modal").querySelector("p");
            modalText.innerHTML = "Пока нечего сохранять в PDF";
            closeModalLoader();
        }
    } catch (e) {
        console.error(e);
    } finally {
        isProcessing = false;
    }
});
function sanitizeFilename(name) {
    // Заменяем недопустимые символы Windows: \ / : * ? " < > | и нежелательные пробелы
    return name
        .replace(/[\\/:*?"<>|]+/g, "")
        .replace(/\s+/g, " ")
        .trim();
}
function getCorrectPrice(calcObj, isEsdPrice) {
    const pieceValue = calcObj.piece || 1;
    const piece = Number(pieceValue);
    const validPiece = isNaN(piece) || piece < 1 ? 1 : piece;

    let basePrice = 0;

    if (isEsdPrice) {
        if (calcObj.position === "table") {
            // как в калькуляторе — всегда ESD, даже если 0
            basePrice = Number(calcObj.price_esd ?? 0);
        } else {
            const esdPrice = Number(calcObj.price_esd);
            basePrice = esdPrice && esdPrice !== 0 ? esdPrice : Number(calcObj.price) || 0;
        }
    } else {
        basePrice = Number(calcObj.price) || 0;
    }

    const total = basePrice * validPiece;

    // 👇 ключевая логика
    if (total === 0) {
        return "По запросу";
    }

    return formatPrice(total);
}

function getFirstPagePdfData(obj) {
    const objID = obj.userData.loadData.pageName;
    const folderName = obj.userData.loadData.folderName;
    const wardrobeType = obj.userData.loadData.wardrobeType;
    if (!objID) throw new Error("Нет корректного ID", objID);

    const isInstrumentalniy = objID === "instrumentalniy";
    console.log({ objID, wardrobeType, obj });

    let firstPagePdfData = undefined;

    if (isInstrumentalniy) {
        firstPagePdfData = parent.servObj.firstPdfPageData[folderName]?.find((el) => el.id === wardrobeType);
    } else {
        firstPagePdfData = parent.servObj.firstPdfPageData[folderName]?.find((el) => el.id === objID);
    }

    if (!firstPagePdfData) {
        console.warn(
            [
                `Предупреждение: данные для objID "${objID}" не найдены, используется запасной вариант с "bazovii".`,
                `Необходимо заполнить данные для "${objID}" в соответствующей Google-таблице, чтобы отображалась корректная информация в PDF-файле.`,
            ].join("\n"),
        );
        firstPagePdfData = parent.servObj.firstPdfPageData.tables?.find((el) => el.id === "bazovii");
    }

    return firstPagePdfData;
}

// Новый listener для "send-pdf" (аналогично "save-pdf", но с Blob и postMessage обратно)
let isSendingEmail = false; // Флаг для предотвращения дубликатов
window.addEventListener("message", async (event) => {
    if (isSendingEmail) return;
    if (!event.data || event.data.type !== "send-pdf") return;

    const modalTextContent = "Спецификация формируется<br />и отправляется на почту";
    openModalLoader(modalTextContent);
    isSendingEmail = true;

    try {
        const servObj = parent.servObj;
        if (!servObj) {
            throw new Error("parent.servObj is undefined");
        }

        let blob = null;
        let fileName = "";
        let mimeType = "application/pdf"; // По умолчанию PDF

        if (servObj.isRedactorMode) {
            // Один стол: генерируем один PDF как Blob
            const screenshotBase64 = await makeObjectScreenshot();
            if (screenshotBase64) {
                const mainScreenshot = document.getElementById("main_screenshot");
                if (mainScreenshot) {
                    mainScreenshot.innerHTML = "";
                    const img = document.createElement("img");
                    img.src = screenshotBase64;
                    mainScreenshot.appendChild(img);
                }
            }

            const link = await getSpecLink();
            const firstPagePdfData = getFirstPagePdfData(servObj.redactorModeObject);
            const { folderName, typeName, glbName } = parent.servObj.redactorModeObject.userData.loadData;

            await createFirstPage(firstPagePdfData, link, glbName, folderName, typeName);
            await createSecondPage();

            const title = getTableTitle(glbName, folderName, typeName);
            fileName = sanitizeFilename(`${title} ${getDate()}.pdf`);
            setPdfFileName(fileName); // Для config

            const element = document.getElementById("content");
            blob = await generatePdfWithPageNumbers(element, config);
            mimeType = "application/pdf";
        } else if (servObj.building._objects.length) {
            // Несколько столов: генерируем ZIP с PDF как Blob
            const JSZip = (await import("jszip")).default;
            const zip = new JSZip();
            const tables = parent.servObj.building._objects;

            for (let i = 0; i < tables.length; i++) {
                const table = tables[i];
                const screenshotBase64 = table.userData.screenshot;
                const title = table.userData.menu_title || "Спецификация";

                if (screenshotBase64) {
                    const mainScreenshot = document.getElementById("main_screenshot");
                    if (mainScreenshot) {
                        mainScreenshot.innerHTML = "";
                        const img = document.createElement("img");
                        img.src = screenshotBase64;
                        mainScreenshot.appendChild(img);
                    }
                }

                const linkToConf = await getSpecLink(true, table.userData.saveObjToJson);
                const firstPagePdfData = getFirstPagePdfData(table);
                const { glbName, folderName, typeName } = table.userData.loadData;

                await createFirstPage(firstPagePdfData, linkToConf, glbName, folderName, typeName);
                createSecondPage(table);
                await new Promise((resolve) => setTimeout(resolve, 100));

                const element = document.getElementById("content");
                const rawTitle = `${title} ${getDate()}_${i + 1}.pdf`;
                fileName = sanitizeFilename(rawTitle); // Временный для PDF внутри ZIP
                const pdfBlob = await generatePdfWithPageNumbers(element, { ...config, filename: fileName });
                zip.file(fileName, pdfBlob);
            }

            blob = await zip.generateAsync({
                type: "blob",
                platform: "UNIX",
                forceZip64: false,
            });
            fileName = `Спецификация ESD ${getDate()}.zip`;
            mimeType = "application/zip";
        } else {
            throw new Error("Пока нечего сохранять в PDF");
        }

        // Отправляем Blob обратно в parent
        if (blob && fileName) {
            parent.postMessage(
                {
                    type: "pdf-ready",
                    blob,
                    fileName,
                    mimeType,
                },
                "*",
            );
        } else {
            throw new Error("Failed to generate file");
        }

        closeModalLoader();
    } catch (e) {
        console.error(e);
        // Отправляем ошибку в parent
        parent.postMessage(
            {
                type: "pdf-error",
                error: e.message,
            },
            "*",
        );

        // Обновляем модалку на ошибку
        const modalText = parent.document.getElementById("loader_modal").querySelector("p");
        if (modalText) modalText.innerHTML = String(e).replace("Error", "Ошибка");
        closeModalLoader();
    } finally {
        isSendingEmail = false;
    }
});

/**
 * Определяет реальные размеры "страницы" из DOM и вставляет переносы
 * @param {string} pageSelector - селектор блока, соответствующего одной странице (например ".page" или ".first-page")
 * @param {string} containerSelector - контейнер, в котором находится динамический контент (например ".second-page")
 * @param {object} options - настройки
 */
function applySmartPageBreaks(pageSelector, containerSelector, options = {}) {
    const pageEl = document.querySelector(pageSelector);
    const container = document.querySelector(containerSelector);
    if (!pageEl || !container) return;

    // Измеряем реальные размеры страницы из DOM
    const pageRect = pageEl.getBoundingClientRect();
    const pageHeightPx = pageRect.height; // например 574px
    const pageWidthPx = pageRect.width; // например 428px

    const {
        safePaddingPx = 32, // "запас снизу" — место, куда контент не должен попадать
        marginTopPx = 0,
        marginBottomPx = 0,
        childSelector = ".spec__row, .configurator__subtitle, .configurator__block--total, h3, h4",
    } = options;

    const innerPageHeight = pageHeightPx - marginTopPx - marginBottomPx;

    // Сбросить старые классы
    container.querySelectorAll(".pageBreakBefore").forEach((el) => el.classList.remove("pageBreakBefore"));

    const children = Array.from(container.querySelectorAll(childSelector));
    if (!children.length) return;

    let accumulated = 0;

    for (const el of children) {
        const rect = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);
        const elFullHeight = rect.height + parseFloat(style.marginTop || 0) + parseFloat(style.marginBottom || 0);

        // Если элемент сам по себе превышает высоту страницы — переносим, но он переполнит новую
        if (elFullHeight + safePaddingPx > innerPageHeight) {
            el.classList.add("pageBreakBefore");
            accumulated = elFullHeight;
            continue;
        }

        // Если следующий элемент не помещается в остаток страницы — переносим его
        if (accumulated + elFullHeight + safePaddingPx > innerPageHeight) {
            el.classList.add("pageBreakBefore");
            accumulated = elFullHeight;
        } else {
            accumulated += elFullHeight;
        }
    }

    // console.log(
    //     `[SmartPageBreaks] page=${pageWidthPx}x${pageHeightPx}, used safePadding=${safePaddingPx}px, total elements=${children.length}`,
    // );
}

/**
 * Объединяет комплекты и штуки разделителей в одну строку, корректируя количество и цену
 * @param {Array} calcValues - массив объектов калькуляции
 * @param {string} singleName - название позиции для штук
 * @param {string} setName - название позиции для комплектов
 * @param {string} singleId - ID позиции для штук
 * @param {string} setId - ID позиции для комплектов
 * @param {string} resultName - название результирующего элемента
 * @param {string} resultPosition - позиция результирующего элемента
 */
function mergeRazdeliteliItems(calcValues, { singleName, setName, singleId, setId, resultName, resultPosition }) {
    const single = calcValues.find((item) => item.name === singleName || item.id === singleId);

    const set = calcValues.find((item) => item.name === setName || item.id === setId);

    // если ничего нет — просто вернуть исходный массив
    if (!single && !set) return calcValues;

    const result = calcValues.filter(
        (item) => item.name !== singleName && item.name !== setName && item.id !== singleId && item.id !== setId,
    );

    const singlePiece = Number(single?.piece || 0);
    const setPiece = Number(set?.piece || 0);

    const totalPiece = singlePiece + setPiece * 5;

    const merged = {
        name: resultName,
        position: resultPosition,
        piece: 1,
        type: `${totalPiece}`,
        active: totalPiece > 0,
        price: (single?.price || 0) * singlePiece + (set?.price || 0) * setPiece,
        price_esd: (single?.price_esd || 0) * singlePiece + (set?.price_esd || 0) * setPiece,
    };

    result.push(merged);

    return result;
}
